import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/typings';

const selectFiles = (state: RootState) => state.files;

export const selectIsUploadingFile = createSelector(
  selectFiles,
  (files) => files.inProgress,
);

export const selectHasFailed = createSelector(
  selectFiles,
  (files) => files.failed ?? false,
);

export const selectProgressForCurrentUploads = createSelector(
  selectFiles,
  (files) =>
    Object.keys(files.uploads).length
      ? Object.values(files.uploads).reduce(
          (acum, cur) => acum + (cur.progress ?? 0),
          0,
        ) / Object.keys(files.uploads).length
      : 0,
);

export const selectUploadErrorMessage = createSelector(
  selectFiles,
  (files) => files.errorMessage,
);

export const selectIsNetworkError = createSelector(
  selectFiles,
  (files) => files.isNetworkError ?? false,
);

// Selector factory to get the error of a specific upload by id
export const selectUploadErrorById = (id: string) =>
  createSelector(selectFiles, (files) => files.uploads[id]?.errorMessage);

// Selector factory to get the error of a specific upload by appletId
// Note: In uploads, the id corresponds to the appletId (Contentful ID)
export const selectUploadErrorByAppletId = (appletId: string) =>
  createSelector(selectFiles, (files) => files.uploads[appletId]?.errorMessage);

// Selector factory to check if a specific upload failed
export const selectUploadFailedById = (id: string) =>
  createSelector(selectFiles, (files) => files.uploads[id]?.failed ?? false);

// Selector factory to check if a specific upload failed by appletId
export const selectUploadFailedByAppletId = (appletId: string) =>
  createSelector(selectFiles, (files) => files.uploads[appletId]?.failed ?? false);
